import { IconPropsType } from '..';

export const YouTubeIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.9543 0 0 8.95431 0 20C0 31.0457 8.9543 40 20 40Z"
      fill="#FF4D43"
    />
    <path
      d="M33.4971 17.0227C33.4857 16.7023 33.4698 16.3818 33.4448 16.0636C33.3403 14.7091 33.1903 13.1568 32.2948 12.0727C31.5289 11.1455 30.3425 10.9364 29.2153 10.8068C27.788 10.6455 26.3539 10.5477 24.9198 10.4932C22.013 10.3818 19.1062 10.4455 16.1994 10.5114C14.7062 10.5455 13.213 10.5773 11.7244 10.6955C9.89708 10.8409 8.01526 11.1091 7.16526 12.9364C6.40162 14.575 6.49481 16.6568 6.48572 18.4227C6.47663 20.0046 6.47208 21.5864 6.53572 23.1682C6.61754 25.2205 6.74026 27.8909 8.9539 28.7909C10.1357 29.2705 11.563 29.3796 12.8266 29.4614C14.1653 29.5477 15.5062 29.5387 16.8471 29.5568C19.6584 29.5977 22.4675 29.5023 25.2789 29.4455C27.2312 29.4068 29.2334 29.3841 31.1016 28.7477C32.713 28.1977 33.1334 26.45 33.3516 24.9341C33.5675 23.4273 33.513 21.9 33.5107 20.3841C33.5107 19.2636 33.538 18.1409 33.4994 17.0227H33.4971ZM17.2584 24.0841V15.8591C19.5903 17.2273 21.8994 18.5841 24.2584 19.9705C21.9062 21.3523 19.5971 22.7091 17.2584 24.0841Z"
      fill="white"
    />
  </svg>
);
